export default {
  moduleTitle: 'Módulo de evaluaciones',
  selectFilterToUse: 'Seleccione el filtro a utilizar',
  selectOption: 'Seleccione una opción',
  nameAndDescription: 'Nombre y descripción',
  type: 'Tipo',
  category: 'Categoría',
  institutional: 'Institucional',
  showOf: 'Mostrar {entity1} de {entity2}',
  welcomeMessage: 'Bienvenido/a, {firstName} {lastName}',
  welcomeDescription: 'Desde este módulo podrás gestionar, revisar y configurar las evaluaciones junto con sus instrumentos asociados. Selecciona un filtro para comenzar.',
}
